import { render } from "./BtnPracticeModes.vue?vue&type=template&id=48cc889b&scoped=true"
import script from "./BtnPracticeModes.vue?vue&type=script&lang=js"
export * from "./BtnPracticeModes.vue?vue&type=script&lang=js"

import "@/css/components/btn-practice-modes.css?vue&type=style&index=0&id=48cc889b&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48cc889b"]])

export default __exports__